import PersonalEmailLayout from "../layouts/PersonalEmailLayout";
import {
    PersonalDiaryPage,
    PersonalEmailsPage,
    PersonalFavouritesPage,
    PersonalMessagesPage,
    PersonalNotificationsPage,
    PersonalRemindersPage,
} from "../pages/personal";
import AdviserSummaryDashboardPage from "../pages/personal/AdviserSummaryDashboardPage";
import { PersonalRemindersPageWrapper } from "../pages/personal/PersonalRemindersPage";

const PersonalRoutes = [{
    path: "/personal/*",
    defaultRoute: "/personal/summary",
    children: [
        {
            path: 'summary',
            roles: [],
            element: AdviserSummaryDashboardPage
        },
        {
            path: 'diary',
            roles: [],
            element: PersonalDiaryPage
        },
        {
            path: 'emails',
            roles: [],
            element: PersonalEmailLayout,
            children: [
                {
                    path: ":folderId",
                    roles: [],
                    element: PersonalEmailsPage
                }
            ]
        },
        {
            path: 'favourites',
            roles: [],
            element: PersonalFavouritesPage
        },
        {
            path: 'messages',
            roles: [],
            element: PersonalMessagesPage
        },
        {
            path: 'notifications',
            roles: [],
            element: PersonalNotificationsPage
        },
        {
            path: 'reminders',
            roles: [],
            element: PersonalRemindersPageWrapper
        }
    ]
}];

export default PersonalRoutes;